import {
  Sprout,
  Hammer,
  Droplets,
  TrendingUp,
  Leaf,
  ClipboardList,
  Wheat,
  GraduationCap,
  Tractor,
  Building2,
} from "lucide-react";

export const IMG = {
  heroGreenhouse:
    "https://images.unsplash.com/photo-1752608277943-e2f36ab66c34?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxwb2x5aG91c2UlMjBncmVlbmhvdXNlJTIwZmFybWluZ3xlbnwwfHx8fDE3ODUyNDE0MTB8MA&ixlib=rb-4.1.0&q=85",
  hydroponics:
    "https://images.pexels.com/photos/37371168/pexels-photo-37371168.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  indianFarmer: "https://images.pexels.com/photos/29039800/pexels-photo-29039800.jpeg",
  agriDrone:
    "https://images.unsplash.com/photo-1535379453347-1ffd615e2e08?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxhZ3JpY3VsdHVyZSUyMGZhcm1pbmclMjBkcm9uZSUyMHRlY2h8ZW58MHx8fHwxNzgzNjAzMjUxfDA&ixlib=rb-4.1.0&q=85",
  texture:
    "https://images.unsplash.com/photo-1548362851-ea052637ad64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMG9yZ2FuaWMlMjBuYXR1cmUlMjB0ZXh0dXJlfGVufDB8fHx8MTc4NDAxMDI1NHww&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Why Us", to: "/why-us" },
  { label: "Projects", to: "/projects" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const HIGHLIGHTS = [
  {
    icon: Sprout,
    title: "Expert Agronomy Team",
    text: "Trained agronomists and horticulture specialists guiding every crop cycle.",
  },
  {
    icon: Hammer,
    title: "End-to-End Execution",
    text: "From design to construction to harvest — we handle it all under one roof.",
  },
  {
    icon: Droplets,
    title: "Water & Resource Efficient",
    text: "Hydroponic systems that use up to 90% less water than traditional farming.",
  },
  {
    icon: TrendingUp,
    title: "Profit-Focused Farming",
    text: "We don't just build farms — we build farms that pay back.",
  },
];

export const SERVICES = [
  {
    id: "hydroponics",
    icon: Leaf,
    title: "Hydroponics Agronomy Consultancy",
    teaser: "Custom soilless farming systems designed for your crop, climate, and budget.",
    description:
      "Grow more in less space — without soil, and with far less water. Our hydroponics consultancy covers the full journey from feasibility to a thriving, producing system.",
    points: [
      "Crop suitability & feasibility assessment",
      "Custom system design (NFT, DWC, drip, vertical towers)",
      "Nutrient formulation & water management planning",
      "Climate and lighting optimization",
      "Ongoing technical support and troubleshooting",
    ],
    ideal: "Leafy greens, herbs, strawberries, exotic vegetables, urban & vertical farms.",
  },
  {
    id: "polyhouse",
    icon: Building2,
    title: "Polyhouse Construction",
    teaser: "Durable, climate-controlled structures built to maximize yield year-round.",
    description:
      "We design and build polyhouses engineered for durability, climate control, and maximum crop protection — built to withstand local weather while optimizing light, humidity, and temperature.",
    points: [
      "Site survey & structural design",
      "Naturally ventilated & fan-pad cooled polyhouses",
      "Shade net houses and greenhouse structures",
      "Irrigation and fertigation system integration",
      "Quality material sourcing & turnkey installation",
    ],
    ideal: "Commercial growers seeking year-round, weather-proof cultivation.",
  },
  {
    id: "farm-management",
    icon: ClipboardList,
    title: "Farm Management Services",
    teaser: "Complete operational support — from planting schedules to post-harvest handling.",
    description:
      "From planning to harvest, we manage the day-to-day so you can focus on the bigger picture.",
    points: [
      "Crop planning & cultivation calendars",
      "On-ground farm supervision",
      "Labor and resource management",
      "Pest & disease monitoring",
      "Post-harvest handling and quality control",
      "Yield tracking and performance reporting",
    ],
    ideal: "Owners & investors who want hands-off, professionally run farms.",
  },
  {
    id: "agronomy",
    icon: Wheat,
    title: "Agronomy Advisory",
    teaser: "Data-driven crop planning, nutrient management, and pest control strategies.",
    description:
      "Science-backed guidance to improve yield, quality, and consistency across every cycle.",
    points: [
      "Soil and water testing recommendations",
      "Nutrient and fertigation scheduling",
      "Integrated pest & disease management",
      "Crop rotation and yield optimization strategies",
    ],
    ideal: "Existing farms looking to boost yield and consistency.",
  },
  {
    id: "training",
    icon: GraduationCap,
    title: "Training & Capacity Building",
    teaser: "Hands-on and online training for farmers, students, and entrepreneurs.",
    description: "We build knowledge, not just infrastructure.",
    points: [
      "On-farm hands-on training",
      "Online consultancy and webinars",
      "Workshops for students, entrepreneurs & institutions",
      "Customized training for corporate & government agri-programs",
    ],
    ideal: "Farmers, students, institutions & agri-entrepreneurs.",
  },
  {
    id: "turnkey",
    icon: Tractor,
    title: "Turnkey Agricultural Projects",
    teaser: "Feasibility studies, design, budgeting, and full project execution.",
    description: "For those starting from scratch, we handle the entire journey.",
    points: [
      "Feasibility studies & business planning",
      "Budgeting and ROI projections",
      "Design and construction",
      "Installation and commissioning",
      "Post-launch operational support",
    ],
    ideal: "New entrants building a farm business from the ground up.",
  },
];

export const STATS = [
  { value: 150, suffix: "+", label: "Farms Built & Managed" },
  { value: 500, suffix: "+", label: "Acres Under Cultivation" },
  { value: 2000, suffix: "+", label: "Farmers & Entrepreneurs Trained" },
  { value: 12, suffix: "+", label: "States Served Across India" },
];

export const TESTIMONIALS = [
  {
    quote:
      "FarmingWave turned an unused half-acre into a thriving hydroponic lettuce farm. Their team stayed with us through every harvest — the yield speaks for itself.",
    name: "Rajesh Menon",
    location: "Kochi, Kerala",
    detail: "NFT Hydroponics · Leafy Greens",
  },
  {
    quote:
      "The polyhouse they built has survived two monsoons without a single issue. Transparent budgeting, honest timelines, and real agronomic expertise.",
    name: "Priya Sharma",
    location: "Nashik, Maharashtra",
    detail: "Naturally Ventilated Polyhouse · Capsicum",
  },
  {
    quote:
      "As a first-time agri-entrepreneur, their turnkey project support was invaluable. From feasibility to my first profitable cycle — one partner, every stage.",
    name: "Arjun Reddy",
    location: "Hyderabad, Telangana",
    detail: "Turnkey Project · Exotic Vegetables",
  },
];

export const VALUES = [
  {
    title: "Sustainability",
    text: "Every system we design conserves water, land, and energy.",
  },
  {
    title: "Transparency",
    text: "Honest budgeting, realistic timelines, no false promises.",
  },
  {
    title: "Farmer-First Thinking",
    text: "Solutions built around your land, climate, and market — not a one-size-fits-all template.",
  },
  {
    title: "Continuous Learning",
    text: "We stay ahead of agri-tech innovation so our clients don't have to.",
  },
];

export const WHY_CHOOSE = [
  {
    title: "Science-backed decisions",
    text: "Every recommendation is rooted in agronomic data, not assumptions.",
  },
  {
    title: "One partner, every stage",
    text: "Consultancy, construction, and management — no juggling multiple vendors.",
  },
  {
    title: "Built for Indian conditions",
    text: "Systems designed for local climate, water availability, and market demand.",
  },
  {
    title: "Transparent costing",
    text: "Clear budgets, no hidden surprises.",
  },
  {
    title: "Long-term partnership",
    text: "We stay involved well beyond installation, through every crop cycle.",
  },
];

export const PROJECTS = [
  {
    name: "Green Valley Greens",
    location: "Pune, Maharashtra",
    crop: "Lettuce & Basil",
    area: "12,000 sq. ft.",
    system: "NFT Hydroponics + Polyhouse",
    result: "3x yield increase vs. open-field farming",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjbdfWBVrIE3qbD098meYd8oDAiM2LCeGe8cz3QXaKY_wzY2Q7kXuCxfEtYnCIiixBRswsSlTguyGIAcZ1450E6bB6jIU2pnnThSW1goqUihnH-IvxYkjdXKW9MQ-fXXJ3z48aG0_ADus6X1aOcqDG01i9aJETlhwU5QcH-rDR_nk0HUsi6xCOCfYYdO6I/s320/IMG20231231104418.jpg",
  },
  {
    name: "Sunrise Agro Farms",
    location: "Nashik, Maharashtra",
    crop: "Coloured Capsicum",
    area: "1 Acre",
    system: "Fan-Pad Cooled Polyhouse",
    result: "Year-round production, 40% premium pricing",
    image:
      "https://images.unsplash.com/photo-1752608277943-e2f36ab66c34?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxwb2x5aG91c2UlMjBncmVlbmhvdXNlJTIwZmFybWluZ3xlbnwwfHx8fDE3ODUyNDE0MTB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "AgriNext Vertical Farm",
    location: "Bengaluru, Karnataka",
    crop: "Exotic Herbs & Microgreens",
    area: "6,500 sq. ft.",
    system: "Vertical Tower Hydroponics",
    result: "8x density per sq. ft., 90% water savings",
    image:
      "https://images.unsplash.com/photo-1535379453347-1ffd615e2e08?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxhZ3JpY3VsdHVyZSUyMGZhcm1pbmclMjBkcm9uZSUyMHRlY2h8ZW58MHx8fHwxNzgzNjAzMjUxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Krishi Bhoomi Estate",
    location: "Greater Noida, UP",
    crop: "Strawberries",
    area: "2 Acres",
    system: "Polyhouse + Drip Fertigation",
    result: "First profitable cycle within 5 months",
    image: "https://images.pexels.com/photos/29039800/pexels-photo-29039800.jpeg",
  },
];

export const BLOG_CATEGORIES = [
  {
    tag: "Beginner Guide",
    title: "Hydroponics 101: Your First Soilless Setup",
    excerpt: "Everything a beginner needs to understand NFT, DWC, and drip systems before investing.",
  },
  {
    tag: "Polyhouse",
    title: "5 Polyhouse Mistakes That Cost Indian Farmers Lakhs",
    excerpt: "Ventilation, orientation, and material choices that make or break your structure.",
  },
  {
    tag: "Crop Guide",
    title: "Growing Coloured Capsicum for Premium Markets",
    excerpt: "A crop-specific playbook for spacing, nutrition, and harvest timing.",
  },
  {
    tag: "Case Study",
    title: "How a Half-Acre Farm Hit 3x Yield in One Season",
    excerpt: "A real FarmingWave client journey from bare land to profitable harvest.",
  },
  {
    tag: "Schemes",
    title: "Government Subsidies for Protected Cultivation in 2026",
    excerpt: "State-wise NHB and RKVY schemes that can fund up to 50% of your polyhouse.",
  },
  {
    tag: "Innovation",
    title: "Sensors, Automation & the Future of Indian Farms",
    excerpt: "How affordable agri-tech is reshaping controlled-environment agriculture.",
  },
];

export const CONTACT = {
  email: "farmingwave@gmail.com",
  location: "Greater Noida, India",
  phone: "+91 8804753106",
};
